export default __webpack_public_path__ + "static/media/1959.db37691c.png";